import script from "./BasketQuickAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./BasketQuickAdd.vue?vue&type=script&setup=true&lang=js"

import "./BasketQuickAdd.vue?vue&type=style&index=0&id=e0e09bc2&scoped=true&lang=css"

import exportComponent from "/Users/darrenlumber/Sites/office-drop-craft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0e09bc2"]])

export default __exports__